
export const getLaborCatalogColumns = (th) => [
  { field: 'matnr', header: th('laborCatalogReport.columns.laborCode') },
  { field: 'laborDescription', header: th('laborCatalogReport.columns.laborDescription') },
  { field: 'meins', header: th('laborCatalogReport.columns.unit') },
  { field: 'yurticiSipMkt', header: th('laborCatalogReport.columns.domesticTime') },
  { field: 'yurtdisiSipMkt', header: th('laborCatalogReport.columns.foreignTime') },
];